/* eslint-disable react/prop-types */
import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import classNames from 'classnames';
import LeafletMap from 'components/common/map/LeafletMap';

const TreeCoverMap = ({ deforestationData, coordinates }) => {
  const [selectedOption, setSelectedOption] = useState(
    deforestationData[0].key
  );

  const handleSelectChange = event => {
    setSelectedOption(event.target.value);
  };

  const selectedItem = deforestationData.find(
    item => item.key === selectedOption
  );

  return (
    <Card className={classNames('h-100', 'overflow-hidden')}>
      <FalconCardHeader
        title={'Tree Cover'}
        titleTag="h5"
        light={true}
        endEl={
          <Form.Select
            className="ps-2 py-0"
            value={selectedOption}
            onChange={handleSelectChange}
          >
            {deforestationData.map(item => (
              <option key={item.key} value={item.key}>
                {item.title.replace('Tree Cover', '').trim()}
              </option>
            ))}
          </Form.Select>
        }
      />
      <Card.Body className="p-0">
        <LeafletMap
          data={{
            coordinates: coordinates,
            mapData: selectedItem
          }}
          className="h-100 bg-white"
          style={{ minHeight: '410px' }}
        />
      </Card.Body>
      <Card.Footer className="bg-white py-2 card-footer-style">
        <h5 className="infrence-info">{selectedItem.info}</h5>
      </Card.Footer>
    </Card>
  );
};

export default TreeCoverMap;
